module.exports = __webpack_public_path__ + "static/media/dont_release.0ea8bc7f.svg";